import React, { useEffect, useState } from "react";
import { Card, CardHeader, Collapse } from "reactstrap";
import Cookies from 'js-cookie';

const HIGHLIGHT_CLASSES = "text-danger ml-q mr-q";
const PortalInformation = ({siteType}) => {
    // Check if the use has selected the portal information to be closed
    const [isOpen, setIsOpen] = useState(true);
    const CARD_TITLE = `This portal has been designed to assist ${siteType} and you, the client to better manage the storage, collection, and recycling of your Used Cooking Oil in a 100% sustainable way.`;

    useEffect(() => {
        setIsOpen(Cookies.get('portalInformationIsOpen')!=="false");
    }, []);
    
    const updateIsOpen = () => {
        Cookies.set('portalInformationIsOpen', `${!isOpen}`, { expires: 1000 });
        setIsOpen(!isOpen);
    };
  return (
    <React.Fragment>
      <Card className="p-1 font-weight-bold">
        <CardHeader style={{backgroundColor: "#23af1c45"}}>
          <div className="flex space-between hand" onClick={updateIsOpen}>
            <div className="pr-1 flex">
              <div>
                <i
                  className="fa fa-info-circle text-primary mr-1"
                  style={{ fontSize: "18px" }}
                  aria-hidden="true"
                />
              </div>
              <div>{CARD_TITLE}</div>
            </div>
            <i
              className={`fa fa-chevron-${isOpen ? "up" : "down"}`}
              aria-hidden="true"
            ></i>
          </div>
        </CardHeader>

        <Collapse isOpen={isOpen} className="mt-1">
            <ul className="pr-2">
                <li className="mb-q">
                    Just click on the 
                    <span className={HIGHLIGHT_CLASSES}>URGENT COLLECTION</span> 
                    button if you need a collection or click on the 
                    <span className={HIGHLIGHT_CLASSES}>SWAP TANK</span> 
                    button if your tank requires maintenance.
                </li>
                <li className="mb-q">
                    If you need a better deal on New Oil, click on the 
                    <span className={HIGHLIGHT_CLASSES}>NEW OIL</span> 
                    button.
                </li>
                <li className="mb-q">
                    To look at and manage your oil usage, click on the
                    <span className={HIGHLIGHT_CLASSES}>MANAGE OIL USAGE</span>
                    button.
                </li>
                <li className="mb-q">
                    Please assist {siteType} to maintain proper and accurate communication by regularly updating your contact details when there are changes. Just click on the 
                    <span className={HIGHLIGHT_CLASSES}>UPDATE MY DETAILS</span>
                    button if there are any changes in your contact details.
                </li>
                <li>
                    For more information about {siteType} and to get more information about how we recycle your used cooking oil and assist you to look after the environment/our planet etc. Just click on the
                    <span className={HIGHLIGHT_CLASSES}>MORE ABOUT US</span>
                    button.
                </li>
            </ul>
        </Collapse>
      </Card>
    </React.Fragment>
  );
};

export default PortalInformation;
